import React from "react";

const SectionHeadline = ({ title, icon, description, backgroundImage }) => {
  return (
    <div
      className="relative font-sans z-40 before:absolute before:inset-0 before:bg-black before:opacity-50 before:z-10"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        data-aos="zoom-in"
        data-aos-duration="1000"
        className="md:min-h-[190px] min-h-[140px] relative z-50 h-full max-w-5xl mx-auto flex flex-col justify-center items-center text-center text-white md:p-6 p-2"
      >
        {icon ? icon : null}
        <h1 className="sm:text-4xl font-serif tracking-widest text-2xl mb-4 md:mb-6">
          {title}
        </h1>
        {description && (
          <p className="sm:text-lg text-base text-center text-gray-200">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default SectionHeadline;

// import React from "react";
// import FooterBg from "../assets/slider1.webp";

// const SectionHeadline = ({ title, icon, description }) => {
//   return (
//     <div
//       className="relative font-sans z-40 before:absolute  before:inset-0 before:bg-black before:opacity-50 before:z-10"
//       style={{
//         backgroundImage: `url(${FooterBg})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       <div
//         data-aos="zoom-in"
//         data-aos-duration="1000"
//         className="md:min-h-[180px] min-h-[150px] relative z-50 h-full max-w-5xl mx-auto flex flex-col justify-center items-center text-center text-white md:p-6 p-2"
//       >
//         {icon ? icon : null}
//         <h1 className="sm:text-4xl font-serif tracking-widest text-2xl mb-6">
//           {title}
//         </h1>
//         {description && (
//           <p className="sm:text-lg text-base text-center text-gray-200">
//             {description}
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SectionHeadline;
